export default {
  title: 'Codice promo',
  fields: {
    preset: {
      label: 'Preimpostazione',
    },
    presets: {
      master: 'Master',
      campaign: 'Campagna',
      one_time: 'Una volta',
    },
    code: {
      label: 'Codice',
      placeholder: 'Inserisci codice',
    },
    discount_type: {
      label: 'Tipo di sconto',
    },
    quantity: {
      label: 'Quantità',
      placeholder: 'Illimitato',
    },
    expires_at: {
      label: 'Data di scadenza',
      placeholder: 'Inserisci data o lascia vuoto',
    },
    franchise: {
      label: 'Codice promo principale per il ristorante e/o per tutto il marchio',
    },
    discount: {
      label: 'Sconto',
    },
    usage_threshold: {
      label: 'Soglia di utilizzo',
    },
  },
  messages: {
    master_warning: 'Creare un nuovo codice promo «master» farà scadere il codice master attuale',
  },
  buttons: {
    save: 'Salva',
    cancel: 'Annulla',
  },
  toasts: {
    promo_code_got_created: 'Codice promo creato',
    promo_code_got_updated: 'Codice promo aggiornato',
  },
};
